
export default {
    splitHelper(text, char = ' ') {
        let splitText = text.split(char);
        return text.split(char)[splitText.length - 1];
    },

    popLastHelper(text, char = ' ') {
        const lastIndexOfSpace = text.lastIndexOf(char);

        if (lastIndexOfSpace === -1) {
            return text;
        }

        return text.substring(0, lastIndexOfSpace);
    }
};